import React, { useEffect, useState } from 'react';
import { api } from '../App';

const LABELS = { ebay_source: 'Euphoric', ebay_store2: 'TNT', walmart: 'Walmart', amazon: 'Amazon' };

export default function ChannelStatusBar() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const res = await api.get('/channels/health');
        if (alive) { setData(res.data); setErr(false); }
      } catch (e) {
        if (alive) setErr(true);
      }
    };
    load();
    const iv = setInterval(load, 60000);
    return () => { alive = false; clearInterval(iv); };
  }, []);

  const barStyle = {
    position: 'fixed', bottom: 0, left: 0, right: 0,
    background: 'rgba(15,18,26,.95)', borderTop: '1px solid var(--border)',
    padding: '8px 12px', display: 'flex', justifyContent: 'center',
    gap: 16, fontSize: 13, zIndex: 100,
    backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)',
  };

  if (err) {
    return <div style={barStyle}><span style={{ color: '#f87171' }}>⚠ Channel status unavailable</span></div>;
  }
  if (!data) {
    return <div style={barStyle}><span style={{ color: 'var(--muted)' }}>Checking channels…</span></div>;
  }

  const items = ['ebay_source', 'ebay_store2', 'walmart', 'amazon'].filter(k => data.channels[k]).map(key => {
    const s = data.channels[key];
    const online = s?.status === 'online';
    return (
      <span key={key} style={{ display: 'flex', alignItems: 'center', gap: 6 }}
        title={s?.error || ''}>
        <span style={{
          width: 8, height: 8, borderRadius: '50%',
          background: online ? '#22c55e' : '#ef4444',
          boxShadow: online ? '0 0 6px #22c55e' : '0 0 6px #ef4444',
        }} />
        <span style={{ color: online ? 'var(--text)' : '#f87171', fontWeight: online ? 400 : 600 }}>
          {LABELS[key]}{online ? '' : ' Offline'}
        </span>
      </span>
    );
  });

  return <div style={barStyle}>{items}</div>;
}
